import * as type from './constants';

export const setClients = (data, total) => ({
  type: type.SET_CLIENT,
  data,
  total
});

export const setAllClients = data => ({
  type: type.SET_ALL_CLIENTS,
  data
});

export const selectClient = clientTypeId => ({
  type: type.SELECT_CLIENT,
  clientTypeId
});

export const handleLoading = status => ({
  type: type.HANDLE_LOADING,
  status
});

export const setClientsFilter = data => ({
  type: type.SET_CLIENTS_FILTER,
  data
});